import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { fetchAll } from '@pec/aion-ui-odata/helpers/fetchAll';
import { QueryBuilder } from '@pec/aion-ui-odata/builders/odataQueryBuilder';
import { OdataComparator } from '@pec/aion-ui-odata/types/odataComparator';
import { ISegmentStatus } from '../interfaces/segmentStatuses';

const { Equals } = OdataComparator;

const name = 'segmentStatuses';

type FetchSegmentStatusesParams = {
  organizationId: string;
};

export const fetchSegmentStatuses = createAsyncThunk(
  `${name}/fetch`,
  async ({ organizationId }: FetchSegmentStatusesParams, { dispatch }) => {
    try {
      const params = new QueryBuilder().filter(f => f.filterBy('segmentType', Equals, 'Module')).toQueryParam();
      const response = await fetchAll<ISegmentStatus>(
        `/api/v2/organizations(${organizationId})/verificationSegmentStatuses/current`,
        { params }
      );
      return response.value;
    } catch (error) {
      dispatch(enqueueRequestErrorSnackbar());
      throw error;
    }
  }
);

export type State = CommonState & {
  segmentStatuses: ISegmentStatus[];
};

const initialState: State = {
  isFetching: false,
  segmentStatuses: [],
  error: null
};

export const segmentStatuses = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchSegmentStatuses.pending, isFetching)
      .addCase(fetchSegmentStatuses.fulfilled, (state, action) => {
        state.segmentStatuses = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchSegmentStatuses.rejected, error);
  }
});

export const { reducer: segmentStatusesReducer } = segmentStatuses;
